import Confirm from "../Confirm";
import { useInternalOptins } from "../hooks/useInternalOptins";

export default function InternalOptins({ config, values = {}, onToggle }) {
  const { groups } = useInternalOptins(config);

  if (!groups || groups.length === 0) return null;

  return (
    <div>
      {groups.map((group) => (
        <div key={group.id}>
          {group.options.map((opt) => (
            <Confirm
              className={"labelSpe"}
              checked={!!values[opt.key]}
              name={opt.key}
              toggle={() => onToggle(opt.key)}
            >
              <span>{opt.label}</span>
            </Confirm>
          ))}
        </div>
      ))}
    </div>
  );
}

